export default "__VITE_ASSET__6edd8f4e__"